export * from './login.component';


// WEBPACK FOOTER //
// /code/frontend/src/app/auth/login/index.ts